/*
 * @Author: Vanny
 * @Date: 2019-08-01 16:36:12
 * @LastEditors: Vanny
 * @LastEditTime: 2020-07-06 15:37:31
 * @Description: 单据管理-仓库
 */
import { call, put } from 'redux-saga/effects';

import { IMPORT_PURCHASE } from '../../config/traceBoxKey';
import * as downApi from '../../services/downApi';
import * as relativeApi from '../../services/customerApi';

const initialState = {
  ruleList: [],
};

export const state = initialState;

export const effects = {
  *fetchSupplierSearch({ payload }) {
    return yield call(relativeApi.requestCustomerSearch, { client_type: '2', ...payload });
  },
  *fetchSupplierAddress({ payload }) {
    return yield call(relativeApi.requestCustomerInfo, payload);
  },
  *fetchStaffList({payload}) {
    const res = yield call(relativeApi.requestStaffList, payload);
    return res.info
  },
  *fetchUploadTemplate() {
    yield call(downApi.requestUploadTemplate, { type: 'purchase_goods' });
  },
  *fetchPreSellDocTemplate() {
    yield call(downApi.requestUploadTemplate, { type: 'pre_sell_doc' });
  },
  *fetchUploadRule() {
    const res = yield call(downApi.requestUploadRule, { type: 'purchase_goods' });

    if (res) {
      yield put({
        type: 'upload/setState',
        payload: { ruleList: res.data },
      });
    }
  },
  *fetchUploadFile({ payload }) {
    const { autoCreate, attrs } = payload;
    yield put({
      type: 'app/fetchUpdateTraceBox',
      payload: {
        key: IMPORT_PURCHASE,
        value: { title: '导入进货单，上传规则', autoCreate, attrs },
      },
    });
    return yield call(downApi.requestUploadFile, payload);
  },
};

export const reducers = {};
